import styles from "./ModalAppointment.module.css";
import FormAppointment from "../FormAppointment/FormAppointment";

const ModalAppointment = ({ doctor }) => {
  return (
    <div className={styles.form}>
      <FormAppointment doctor={doctor} />
    </div>
  );
};

export default ModalAppointment;